import { HeaderBar, UI_STYLES } from "@/components/ui";
import { Info } from "lucide-react";
import BottomTabBar, { AstroPrognosisTab } from "@/components/ui/BottomTabBar";
import ModalCenterSheet from "@/components/ui/modals/ModalCenterSheet";
import { motion } from "framer-motion";
import { useZodiacPrognosisScreenViewModel } from "./ZodiacPrognosisScreenViewModel";
import { ZodiacPrognosisModalContent } from "./ui/ZodiacPrognosisModalContent";
import { ZodiacPrognosisFree } from "./ui/ZodiacPrognosisFree";
import { ZodiacPrognosisPremium } from "./ui/ZodiacPrognosisPremium";
import ScreenLoader from "@/components/ui/ScreenLoader";
import { useSafariPadding } from "@/hooks/useSafaryPadding";
import zodiacBackground from "@/assets/img/d_start_background.png";
import { Helmet } from "react-helmet-async";

export default function ZodiacPrognosisScreen() {
  const {
    prognoses,
    selectedPrognose,
    selectPrognosis,
    isDescriptionOpen,
    setIsDescriptionOpen,
    navigateToAstroPrognosis,
    navigateToHome,
    navigateToTelegram,
    navigateToSubscribe,
    isPrognosisForYear,
    selectPrognosisForYear,
    isLoading,
    isSubscribed, 
    zodiac,
  } = useZodiacPrognosisScreenViewModel();

  const paddingBottom = useSafariPadding();
  return (
    <>
      <Helmet>
        <title>Зодиакальный прогноз по знакам зодиака | Мир Звёзд</title>
        <meta name="description" content="Персональный зодиакальный прогноз для всех 12 знаков зодиака. Узнайте, что готовят звезды для Овна, Тельца, Близнецов, Рака, Льва, Девы, Весов, Скорпиона, Стрельца, Козерога, Водолея и Рыб. Гороскоп на день, неделю и месяц." />
        <meta name="keywords" content="зодиакальный прогноз, знаки зодиака, гороскоп, овен, телец, близнецы, рак, лев, дева, весы, скорпион, стрелец, козерог, водолей, рыбы, астрология" />
        <meta name="author" content="bpTech" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Зодиакальный прогноз по знакам зодиака | Мир Звёзд" />
        <meta property="og:description" content="Персональный зодиакальный прогноз для всех 12 знаков зодиака. Узнайте, что готовят звезды для вашего знака." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://мир-звезд.рф/zodiac-prognosis" />
      </Helmet>
        <ModalCenterSheet
        open={isDescriptionOpen}
        onClose={() => setIsDescriptionOpen(false)}
        backgroundUrl={zodiacBackground}
      >
        <ZodiacPrognosisModalContent
          setIsDescriptionOpen={setIsDescriptionOpen}
        />
      </ModalCenterSheet>
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className={`h-full ${UI_STYLES.backgroundDarkBlue}`}
      >
        <ScreenLoader isLoading={isLoading || isSubscribed === null} />
        <div className={`flex flex-col h-full`}>
          
          <HeaderBar
            title="Зодиакальный прогноз"
            onBack={navigateToHome}
            rightContent={
              <button
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition flex-shrink-0"
                onClick={() => setIsDescriptionOpen(true)}
              >
                <Info className="w-6 h-6 text-white" />
              </button>
            }
          />
          {/* Контент */}
          {isSubscribed? (
            <ZodiacPrognosisPremium
              zodiac={zodiac}
              prognoses={prognoses}
              selectedPrognose={selectedPrognose}
              selectPrognosis={selectPrognosis}
              isPrognosisForYear={isPrognosisForYear}
              selectPrognosisForYear={selectPrognosisForYear}
              paddingBottom={paddingBottom}
            />
          ) : (
            <ZodiacPrognosisFree
              zodiac={zodiac}
              navigateToSubscribe={navigateToSubscribe}
              navigateToTelegram={navigateToTelegram}
            />
          )}
          {/* Tab Layout */}

          <BottomTabBar
            activeTab={AstroPrognosisTab.Zodiac}
            onAstroPrognosisClick={() => navigateToAstroPrognosis()}
            onZodiacPrognosisClick={() => {}}
          />
          {/* Стили для скрытия скроллбара */}
          <style>{`
        .hide-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
        </div>
      </motion.div>
    </>
  );
}
